import { ResourceLanguage } from 'i18next';

export const de: ResourceLanguage = {
  translation: {
    common: {
      other: 'Andere',
      noOptionsFound: 'Keine Optionen gefunden',
      noOptionsAvailable: 'Keine Optionen verfügbar',
      compared: 'Verglichen',
      loading: 'Laden...',
    },
    dimension: {
      'customers.country.United States': 'Vereinigte Staaten',
      'customers.country.Germany': 'Deutschland',
      'customers.country.United Kingdom': 'Vereinigtes Königreich',
      'customers.country.New Zealand': 'Neuseeland',
      'customers.country.Belgium': 'Belgien',
      'customers.country.Australia': 'Australien',
      'customers.country.Canada': 'Kanada',
      'customers.country.Iceland': 'Island',
      Other: 'Andere',
    },
    charts: {
      label: 'Beschriftung',
      primaryPeriod: 'Primärzeitraum',
      comparisonPeriod: 'Vergleichszeitraum',
      'menuOptions.downloadCSV': 'CSV herunterladen',
      'menuOptions.downloadPNG': 'PNG herunterladen',
      'menuOptions.downloadXLSX': 'XLSX herunterladen',
      errorTitle: 'Etwas ist schiefgelaufen.',
      errorMessage: 'Beim Laden des Diagramms ist ein Fehler aufgetreten.',
      emptyTitle: 'Keine Ergebnisse.',
      emptyMessage: 'Hier ist es etwas leer.',
      tablePaginated: {
        pagination: 'Seite {{page}} von {{totalPages}}',
      },
      pivotTable: {
        total: 'Gesamt',
      },
      kpiChart: {
        noPreviousData: 'Keine vorherigen Daten',
        equalComparison: 'Keine Veränderung',
      },
      scatterChart: {
        noValue: 'Kein Wert',
      },
    },
    editors: {
      errorTitle: 'Etwas ist schiefgelaufen.',
      dateRangePicker: {
        custom: 'Benutzerdefiniert',
        backToPresets: 'Zurück zu den Voreinstellungen',
        apply: 'Anwenden',
        placeholder: 'Datumsbereich auswählen',
      },
      filterBuilder: {
        clearAll: 'alle löschen',
        addFilter: 'Filter hinzufügen',
        betweenAnd: 'und',
        and: 'und',
        or: 'oder',
        disableOrOperatorToolTip:
          'Berechnungen und Kategoriefilter können nur mit "und" kombiniert werden, nicht mit "oder".',
        is: 'ist',
        isNot: 'ist nicht',
        isOneOf: 'ist eines von',
        isNotOneOf: 'ist keines von',
        contains: 'enthält',
        equals: 'Gleich',
        doesNotEqual: 'Ungleich',
        greaterThanOrEqualTo: 'Größer als oder gleich',
        lessThanOrEqualTo: 'Kleiner als oder gleich',
        between: 'Zwischen',
      },
    },
    defaults: {
      granularityOptions: {
        second: 'Sekunde',
        minute: 'Minute',
        hour: 'Stunde',
        day: 'Tag',
        week: 'Woche',
        month: 'Monat',
        quarter: 'Quartal',
        year: 'Jahr',
      },
      comparisonPeriodOptions: {
        previousPeriod: 'Vorheriger Zeitraum',
        previousWeek: 'Vorherige Woche',
        previousMonth: 'Vorheriger Monat',
        previousQuarter: 'Vorheriges Quartal',
        previousYear: 'Vorheriges Jahr',
        samePeriodLastWeek: 'Gleicher Zeitraum letzte Woche',
        samePeriodLastMonth: 'Gleicher Zeitraum letzten Monat',
        samePeriodLastQuarter: 'Gleicher Zeitraum letztes Quartal',
        samePeriodLastYear: 'Gleicher Zeitraum letztes Jahr',
      },
      dateRangeOptions: {
        today: 'Heute',
        yesterday: 'Gestern',
        thisWeek: 'Diese Woche',
        lastWeek: 'Letzte Woche',
        weekToDate: 'Woche bis heute',
        last7Days: 'Letzte 7 Tage',
        next7Days: 'Nächste 7 Tage',
        last30Days: 'Letzte 30 Tage',
        next30Days: 'Nächste 30 Tage',
        thisMonth: 'Dieser Monat',
        lastMonth: 'Letzter Monat',
        nextMonth: 'Nächster Monat',
        thisQuarter: 'Dieses Quartal',
        lastQuarter: 'Letztes Quartal',
        nextQuarter: 'Nächstes Quartal',
        quarterToDate: 'Quartal bis heute',
        last6Months: 'Letzte 6 Monate',
        last12Months: 'Letzte 12 Monate',
        thisYear: 'Dieses Jahr',
        lastYear: 'Letztes Jahr',
        nextYear: 'Nächstes Jahr',
        yearToDate: 'Jahr bis heute',
      },
    },
    granularity: {
      quarter: '{{quarter}}. Quartal {{year}}',
    },
  },
};
